import React from "react";
import { Minus, TrendingDown, TrendingUp } from "lucide-react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface CardDetailsModalPriceProps {
  price: string;
  priceChange24hr?: number | null;
}

const CardDetailsModalPrice: React.FC<CardDetailsModalPriceProps> = ({
  price,
  priceChange24hr,
}) => {
  const priceChange24hrNumber = Number(priceChange24hr);

  return (
    <Card>
      <CardHeader>
        <h3 className="text-lg font-semibold text-center">
          Current Market Price
        </h3>
      </CardHeader>
      <CardContent>
        <div className="text-center space-y-2">
          <div className="text-3xl font-bold text-green-600">{price}</div>
          {priceChange24hr !== undefined && priceChange24hr !== null && (
            <div
              className={cn(`flex items-center justify-center gap-1 text-sm`, {
                "text-green-600": priceChange24hrNumber > 0,
                "text-red-600": priceChange24hrNumber < 0,
                "text-yellow-600": priceChange24hrNumber === 0,
              })}
            >
              {priceChange24hrNumber > 0 && <TrendingUp className="h-4 w-4" />}
              {priceChange24hrNumber < 0 && (
                <TrendingDown className="h-4 w-4" />
              )}
              {priceChange24hrNumber === 0 && <Minus className="h-4 w-4" />}
              {Math.abs(priceChange24hrNumber).toFixed(2)}% (24h)
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default CardDetailsModalPrice;
